import React, { useState, useEffect } from 'react'
import { Input, Button, Card, Modal, Form, message } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import _ from 'lodash'
import { paginationInit, formatMessageNew, initCurryingObj } from '@/utils/common'
import { modalConfirm, modalError } from '@/utils/modalUtils'
import { storeSave, getStoreQuery, storeModifyStatus } from '@/services/rfid/rfidConfig/rfidStore'
import { hasPermission } from '@/annotations/nike-react'
import { CONFIG_STATUS } from '@/utils/types'
import AntdTable from '@/components/table/AntdTable'

const statusObj = initCurryingObj(CONFIG_STATUS)
const menu_rfid_configuration_store = 'menu_rfid_configuration_store'
const StorePage = () => {
  const [newModalForm] = Form.useForm()
  const [tableList, setTableList] = useState([])
  const [queryFlag, setQueryFlag] = useState(false)
  const [statusFlag, setStatusFlag] = useState(false)
  const [pagination, setPagination] = useState(paginationInit)
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [visibleFlag, setVisibleFlag] = useState(false)

  const tableColumns = [
    {
      title: formatMessageNew('languageObj.rfidConfiguration.storeCode'),
      dataIndex: 'storeCode'
    },
    {
      title: formatMessageNew('languageObj.rfidConfiguration.storeDesc'),
      dataIndex: 'storeDesc',
      width: '50%'
    },
    {
      title: formatMessageNew('languageObj.rfidConfiguration.storeStatus'),
      dataIndex: 'status',
      render: text => statusObj[text]
    },
    {
      title: formatMessageNew('languageObj.rfidConfiguration.createTime'),
      dataIndex: 'createTime'
    },
    {
      title: formatMessageNew('languageObj.rfidConfiguration.updateTime'),
      dataIndex: 'updateTime'
    }
  ]
  useEffect(() => {
    searchDataFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryFlag])

  useEffect(() => {
    if (selectedRowKeys.length === 0 && statusFlag) setStatusFlag(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRowKeys])

  const handleTableChange = pagina => {
    const params = {
      ...pagination,
      currentPage: pagina.current,
      pageSize: pagina.pageSize
    }
    setPagination({ ...params })
    setQueryFlag(!queryFlag)
  }
  const searchDataFun = () => {
    const params = {
      asc: true,
      current: pagination.currentPage,
      param: {
        storeConfigurationDtoList: [
          {
            createTime: '',
            // status: true,
            storeCode: '',
            storeDesc: '',
            updateTime: ''
          }
        ]
      },
      size: pagination.pageSize
    }

    getStoreQuery(params).then(res => {
      const dt = res.resultData
      setTableList(dt.records)
      const pg = {
        ...pagination,
        total: dt.total
      }
      setPagination(pg)
    })
  }
  const disabledDataFun = () => {
    modalConfirm(
      {
        content: statusFlag
          ? formatMessageNew('languageObj.rfidConfiguration.enableStoreDataTip')
          : formatMessageNew('languageObj.rfidConfiguration.disabledStoreDataTip')
      },
      () => {
        const params = []
        for (let index = 0; index < tableList.length; index++) {
          const element = tableList[index]
          if (selectedRowKeys.indexOf(element.id) !== -1) {
            params.push({
              storeCode: element.storeCode,
              storeDesc: element.storeDesc,
              id: element.id,
              status: statusFlag
            })
          }
        }
        storeModifyStatus({
          storeConfigurationDtoList: params
        }).then(() => {
          message.success(formatMessageNew('languageObj.commonLocale.success'))
          setSelectedRowKeys([])
          setQueryFlag(!queryFlag)
        })
      }
    )
  }
  const handleUserOk = () => {
    newModalForm
      .validateFields()
      .then(values => {
        const params = {
          status: true,
          storeCode: values.storeCode,
          storeDesc: values.storeDesc
        }

        storeSave(params)
          .then(() => {
            message.success(formatMessageNew('languageObj.commonLocale.success'))
            setQueryFlag(!queryFlag)
            setVisibleFlag(false)
          })
          .catch(err => {
            const errorCode = err.errorCode
            let str = 'languageObj.rfidConfiguration.error_' + errorCode
            modalError({
              content: formatMessageNew(str)
            })
          })
      })
      .catch(errorInfo => {
        console.log('errorInfo', errorInfo)
      })
  }
  const handleUserCancel = () => {
    setVisibleFlag(false)
  }
  const onSelectChange = newSelectedRowKeys => {
    const matchedObjects = _.filter(tableList, obj => _.includes(newSelectedRowKeys, obj.id))
    let allFalse = _.every(matchedObjects, ['status', false])
    let allTrue = _.every(matchedObjects, ['status', true])
    if (allFalse) {
      // 全是false则启用
      setStatusFlag(true)
    } else if (allTrue) {
      // 全是true则禁用
      setStatusFlag(false)
    } else {
      // 有true，有false则禁用
      setStatusFlag(false)
    }
    setSelectedRowKeys(newSelectedRowKeys)
  }
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange
  }
  const hasSelected = selectedRowKeys.length > 0
  return (
    <div>
      <Card bordered={false} bodyStyle={{ padding: 4 }}>
        {hasPermission(menu_rfid_configuration_store) ? (
          <div>
            <Button
              type="primary"
              style={{ marginLeft: '16px', marginTop: '10px' }}
              onClick={() => {
                newModalForm.resetFields()
                setVisibleFlag(true)
              }}
            >
              <PlusOutlined />
              {formatMessageNew('languageObj.rfidConfiguration.addStore')}
            </Button>
            <Button
              type="primary"
              danger={!statusFlag}
              disabled={!hasSelected}
              style={{ marginLeft: '20px', marginTop: '10px' }}
              onClick={() => {
                disabledDataFun()
              }}
            >
              {statusFlag
                ? formatMessageNew('languageObj.rfidConfiguration.enable')
                : formatMessageNew('languageObj.rfidConfiguration.disabled')}
            </Button>
          </div>
        ) : null}
        <div className="content-container">
          <AntdTable
            rowKey={record => record.id}
            dataSource={tableList}
            columns={tableColumns}
            pagination={pagination}
            onChange={handleTableChange}
            rowSelection={hasPermission(menu_rfid_configuration_store) && rowSelection}
          />
        </div>
      </Card>
      <Modal
        open={visibleFlag}
        maskClosable={false}
        className="nike_modal"
        width="40%"
        title={formatMessageNew('languageObj.rfidConfiguration.addStore')}
        onOk={handleUserOk}
        onCancel={handleUserCancel}
        destroyOnClose
      >
        <Form
          name="basic"
          form={newModalForm}
          labelCol={{
            span: 8
          }}
          wrapperCol={{
            span: 16
          }}
          initialValues={{}}
        >
          <Form.Item
            rules={[
              {
                required: true
              }
            ]}
            label={formatMessageNew('languageObj.rfidConfiguration.storeCode')}
            name="storeCode"
          >
            <Input />
          </Form.Item>
          <Form.Item label={formatMessageNew('languageObj.rfidConfiguration.storeDesc')} name="storeDesc">
            <Input maxLength={256} showCount />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  )
}
export default StorePage
